import React from "react"
import TeacherFormContainer from "../Container/TeacherFormContainer"
import PreferredWorkLocation from "./PreferredWorkLocationsForm"
import { connect } from "react-redux"
import { updatePersonalDetails } from "../../redux/homePage/homePage.actions"
import { notify } from "react-notify-toast"
import { API } from "../../API"

class preferredWorkLocation extends React.Component {
  state = {
    preferred_country1: this.props.user.preferred_country1,
    preferred_city1: this.props.user.preferred_city1,
    preferred_country2: this.props.user.preferred_country2,
    preferred_city2: this.props.user.preferred_city2,
    preferred_country3: this.props.user.preferred_country3,
    preferred_city3: this.props.user.preferred_city3,
    preferred_online: this.props.user.preferred_online === undefined ? true : this.props.user.preferred_online,
    cityList: [],
    countryList: [],
  }

  componentDidMount() {
    this.getCountries();
  }

  onSelectCountry = (country) => {
    const cityList = this.state.countryList[country];
    this.setState({ cityList });
  }

  getCountries = async () => {
    try {
      const res = await API.getCountriesV2();
      this.setState({
        countryList: res?.data?.data
      }, () => {
        if (this.props.user.preferred_country1) {
          this.onSelectCountry(this.props.user.preferred_country1)
        }
      });
    } catch (err) {
      console.log('getCountries Err:', err);
    }
  }

  handleStateChange = (e) => {
    this.setState({ [e.target.id]: e.target.value })

    if (e.target.id === "preferred_country1") {
      this.onSelectCountry(e.target.value)
    }
  }

  handleOnlineCheck = () => {
    this.setState({ preferred_online: !this.state.preferred_online });
  };

  handleClear = () => {
    this.setState({ preferred_country1: '', preferred_city1: '', preferred_country2: '', preferred_city2: '',
      preferred_country3: '', preferred_city3: '',  });
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const fields = [
      "preferred_country1",
      "preferred_city1",
      "preferred_country2",
      "preferred_city2",
      "preferred_country3",
      "preferred_city3",
    ]

    if (!this.props.user?.is_childhood_teacher) {
      fields.push("preferred_online")
    }

    let errors = false
    for (let field of fields) {
      const input = document.getElementById(field);
      if (!input.reportValidity()) {
        errors = true;
        break;
      }
    }

    if (errors) {
      notify.show(
        "You are missing one or more field(s)!"
      )
    }

    if (!errors) {
      this.props.updatePersonalDetails({ ...this.state })
    }
  }

  tabs = [
    {
      pathname: "/personalDetails",
      text: "Personal Details",
    },
    {
      pathname: "/emergencyContact",
      text: "Emergency",
    },
    {
      pathname: "/PreferredWorkLocations",
      text: "Work Locations",
      active: true,
    },
  ]

  render() {
    return (
      <div>
        <TeacherFormContainer
          header="Personal Information"
          tabs={this.tabs}
          handleSubmit={this.handleSubmit}
        >
          <PreferredWorkLocation
            handleStateChange={this.handleStateChange}
            handleNumberChange={this.handleNumberChange}
            handleOnlineCheck={this.handleOnlineCheck}
            handleClear={this.handleClear}
            state={this.state}
          />
        </TeacherFormContainer>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
  }
}

const mapDispatchToProps = (dispatch) => ({
  updatePersonalDetails: (details) => dispatch(updatePersonalDetails(details)),
})

export default connect(mapStateToProps, mapDispatchToProps)(preferredWorkLocation)
